// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_hh","advertCardHeader__actions":"c-a_hi","advertCardHeader__bottomLabel":"c-a_hj"};